export default "__VITE_ASSET__afIiGeos__"